var _slicedToArray = require("@babel/runtime/helpers/slicedToArray");
const _require = require('@truqc/content-path'),
  appendPath = _require.appendPath,
  getContentValues = _require.getContentValues;
const _require2 = require('lodash'),
  isPlainObject = _require2.isPlainObject;
const _require3 = require('../../lib/evaluateSource'),
  evaluateSource = _require3.evaluateSource;

/**
  * @function evalute - evaluate itiChecklistFilterBehavior
  */

const evaluate = async (source, content, parentContentPath, transientContext, nativeFunctions) => {
  const map = await evaluateSource(source.map, content, parentContentPath, transientContext, nativeFunctions);
  if (map === undefined || !isPlainObject(map)) {
    return undefined;
  }
  const asyncEvery = async (arr, predicate) => {
    for (let i = 0; i < arr.length; i += 1) {
      const value = arr[i];
      // eslint-disable-next-line no-await-in-loop
      if (!(await predicate(value))) return false;
    }
    return true;
  };
  return asyncEvery(Object.keys(map), async path => {
    const options = map[path];
    const evaluatedOptions = await evaluateSource(options, content, parentContentPath, transientContext, nativeFunctions);
    const fullPath = appendPath(parentContentPath, path);
    const values = getContentValues(fullPath, content);
    return values.some(value => {
      const _Object$keys = Object.keys(value),
        _Object$keys2 = _slicedToArray(_Object$keys, 1),
        identifier = _Object$keys2[0];
      if (evaluatedOptions.includes(identifier)) {
        return true;
      }
      return false;
    });
  });
};
module.exports = {
  evaluate
};